<template>
	<div v-if="localWarnings.length > 0" style="border: 1px black solid; border-radius: 5px" class="flex flex-row gap-4 w-full px-4 py-2">
		<div class="flex items-center px-4">
			<FontAwesomeIcon :icon="['far', 'warning']" size="3x" class="text-yellow-600" />
		</div>
		<div class="flex flex-col gap-2">
			<div class="flex justify-between">
				<h3 class="text-lg font-semibold">{{ header }}</h3>
			</div>
			<div v-for="(error, index) in localWarnings" :key="index">
				<span v-html="error"></span>
			</div>
		</div>
		<div class="flex justify-end flex-grow">
			<FontAwesomeIcon :icon="['far', 'times-circle']" size="lg" class="text-red-600 cursor-pointer" @click="clearWarnings" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { onMounted, PropType, ref, watch } from "vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faWarning } from "@fortawesome/pro-regular-svg-icons"
import I2FormField from "@/crispify/crispy-components/I2FormField.vue"
library.add(faWarning)
const props = defineProps({
	header: {
		type: String,
		required: false,
		default: "Warnings",
	},
	warningMessages: {
		type: Array as PropType<string[]>,
		required: true,
		default: () => [],
	},
})

const localWarnings = ref<string[]>([])

onMounted(async () => {
	localWarnings.value = props.warningMessages
})

watch(
	() => props.warningMessages,
	(newWarnings) => {
		localWarnings.value = newWarnings
	}
)

function clearWarnings() {
	localWarnings.value = []
}
</script>

<style scoped></style>
